module.exports = __webpack_public_path__ + "img/image4.e6cb0bec.png";